import CoveoAiIcon from '../svg-elements/coveo-ai-icon/coveoAiIcon.vue';
import { CloseIcon } from '../svg-elements/close-icon';
export default {
  name: 'CoveoAINotification',
  components: {
    CoveoAiIcon,
    CloseIcon
  },
  props: {
    displayIcon: {
      type: Boolean,
      default: false
    },
    isCoveoExpanded: {
      type: Boolean,
      default: false
    },
    isFirstView: {
      type: Boolean,
      default: false
    },
    componentStyle: {
      type: String,
      default: 'loggedOut',
      validator: value => ['loggedIn', 'loggedOut'].includes(value)
    }
  },
  emits: ['update:isCoveoExpanded'],
  computed: {
    isExpanded() {
      return this.isCoveoExpanded;
    },
    isLoggedIn() {
      return this.componentStyle === 'loggedIn';
    },
    rootClass() {
      return this.isLoggedIn ? 'coveo-logged-in-info' : 'coveo-logged-out-info';
    },
    triggerLabel() {
      return this.$slots['panel-title'] ? undefined : 'Coveo AI';
    }
  },
  methods: {
    handleExpand() {
      this.$emit('update:isCoveoExpanded', true);
    },
    handleCollapse() {
      this.$emit('update:isCoveoExpanded', false);
    },
    clickOutside(event) {
      if (this.isExpanded && this.$el && !this.$el.contains(event.target)) {
        this.handleCollapse();
      }
    },
    handleFocusOut(event) {
      const relatedTarget = event.relatedTarget;
      if (!relatedTarget || !this.$el.contains(relatedTarget)) {
        this.handleCollapse();
      }
    },
    handleEscapeKey(event) {
      if (event.key === 'Escape' && this.isExpanded) {
        this.handleCollapse();
      }
    }
  },
  mounted() {
    document.addEventListener('click', this.clickOutside);
    document.addEventListener('keydown', this.handleEscapeKey);
  },
  beforeUnmount() {
    document.removeEventListener('click', this.clickOutside);
    document.removeEventListener('keydown', this.handleEscapeKey);
  }
};